import React, { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { StateContext } from '../../contexts/stateContext';
import { types_dict } from '../../static/types_dictionary';
import { nakshatra_yoni_dictionary, yoni_dictionary } from '../../static/jyotish_local';
import { drawProfile, drawType } from '../utilsDesign';
import { getJyotish } from '../Edu/utilsJyotish';
import { getPentaDesign } from '../utilsPenta';
import { Preloader } from './kit';
import { TooltipH } from './TooltipH';
import { default_design } from '../../static/default_design';
import { Icon } from './Icon';


const avatarImageUrl = (image, updated) => {
  if (!image) return '';
  const ts = updated ? new Date(updated).getTime() : '';
  if (!ts || Number.isNaN(ts)) return image;
  return `${image}${image.includes('?') ? '&' : '?'}v=${ts}`;
};

const getYoniEmojiForAvatar = (avatar) => {
  if (!avatar?.dob || !avatar?.aggr?.city?.location) return null;
  try {
    const result = getJyotish(avatar);
    const nakshatra = result?.kundli?.dasha?.birthNakshatra;
    if (!nakshatra || typeof nakshatra !== 'string') return null;
    const normalized = nakshatra.toLowerCase().replace(/\s+/g, '_');
    const yoniId = nakshatra_yoni_dictionary[normalized]?.yoniId || null;
    const entry = yoniId
      ? (yoni_dictionary[yoniId] || Object.values(yoni_dictionary).find((y) => y.id === yoniId))
      : null;
    return entry?.emoji || nakshatra_yoni_dictionary[normalized]?.yoniEmoji || null;
  } catch {
    return null;
  }
};


export function Avatar(props) {

  const {
    mode = 'hd',
    user,
    avatar = {},
    penta = {},
    // type = 'calc',
    type,
    size,
    composite,
    style = {},
    className,
    active,
    onClick,
    onClickOpen = true,
    tooltip = { 'name': true, 'type': true, 'profile': true },
    noFace
  } = { ...props }

  const context = { ...useContext(StateContext), ...useContext(StateContext) };

  avatar.design = avatar.design || default_design;

  // console.log('avatar = ', avatar);
  const design = avatar.design 
    ? avatar.design 
    : penta 
      ? penta.pentaDesign || default_design
      : {};
  // design = design || avatar;
  // if (!design) design = {}

  const getTypeClass = (design) => {
    if (!design) return ''
    return design['type'] ? design['type'].toLowerCase() : ''
  }
  const getTypeColor = (design) => {
    if (!design) return ''
    return design['type'] ? types_dict[design['type']]['bgColor'] : ''
  }


  return (
    <>

      {tooltip
        && <TooltipH title={<>{tooltip.name && <b>{avatar.name}</b>} {(tooltip.type || tooltip.profile)} {tooltip.type && avatar.design && drawType(avatar.design.type, 'compact')} {tooltip.profile && drawProfile(design['profile'])}</>}>
          <div
            className={`x_choose_user_ava x_choose_user_ava--${size ? size : ''}`}
            style={{
              cursor: (onClickOpen || onClick) ? 'pointer' : 'inherit',
            }}
          >
            {mode === 'hd' ? <AvatarCircle {...props} /> : <AvatarCircleYoni {...props} />}
          </div>
        </TooltipH>
      }
      {!tooltip && <AvatarCircle {...props} />}
    </>
  )
}


export function AvatarCircle({
  visual = 'hd',
  user,
  avatar = {},
  penta = {},
  type,
  celeb,
  // type = 'calc',
  size,
  composite,
  style = {},
  className,
  active,
  onClick,
  onClickOpen,
  noFace
}) {
  const context = { ...useContext(StateContext), ...useContext(StateContext) };

  // console.log('avatar = ', avatar);
  const design = avatar.design ? avatar.design : penta ? penta.pentaDesign || getPentaDesign(penta) : {};
  // design = design || avatar;
  // if (!design) design = {}

  const getTypeClass = (design) => {
    if (!design) return ''
    return design['type'] ? design['type'].toLowerCase() : ''
  }
  const getTypeColor = (design) => {
    if (!design) return ''
    return design['type'] ? types_dict[design['type']]['bgColor'] : ''
  }
  const navigate = useNavigate();
  
  const profile = avatar.design?.profile;
  const hasProfile = Array.isArray(profile) && profile.length === 2;
  const hasDesign = Boolean(
    avatar.design
    && avatar.design.id !== 'dummy'
    && (avatar.design.id || hasProfile)
  );

  return (
    <>

        <div
        className={`x_user_ava ${active ? 'active' : ''}  ${type ? `x_user_ava--${type}` : ''} ${getTypeClass(design)} ${Boolean(className) ? className : ''}`}
        style={{
          backgroundColor: getTypeColor(design),
          borderWidth: '0.07em',
          ...style
        }}
        onClick={() => {
          onClick && onClick();
          onClickOpen && navigate(`/u/${user ? user.token : avatar.token}`);
        }}
      >
        {!noFace && !context.state.hideNames && Boolean(avatar.image) && <div className="x_user_ava_img"
          style={{
            backgroundImage: `url(${avatarImageUrl(avatar.image, avatar.updated)})`,
            ...style,
          }}
        />}


        {!avatar.design && !penta && <Preloader />}

        {visual === 'hd' && <>
          {hasDesign && <div className="x_user_ava_type"
            style={{ textDecoration: 'none' }}
          >{drawProfile(design.profile)}</div>}
          </>}
        
        
        {!penta.members && !hasDesign && <div className="x_user_ava_type"
          style={{ textDecoration: 'none', lineHeight: '1' }}
        >
          <Icon size={'sm'}>question_mark</Icon>
        </div>}

        {penta.members && <div className="t_icon"
          style={{ textDecoration: 'none' }}
          >group</div>}
        </div>

    </>
  )
}

export function AvatarCircleYoni({
  user,
  avatar = {},
  penta = {},
  type,
  celeb,
  // type = 'calc',
  size,
  composite,
  style = {},
  className,
  active,
  onClick,
  onClickOpen,
  noFace
}) {
  const context = { ...useContext(StateContext), ...useContext(StateContext) };

  // console.log('avatar = ', avatar);
  const design = avatar.design ? avatar.design : penta ? penta.pentaDesign || getPentaDesign(penta) : {};
  // design = design || avatar;
  // if (!design) design = {}

  const getTypeClass = (design) => {
    if (!design) return ''
    return design['type'] ? design['type'].toLowerCase() : ''
  }
  const getTypeColor = (design) => {
    if (!design) return ''
    return design['type'] ? types_dict[design['type']]['bgColor'] : ''
  }
  const navigate = useNavigate();

  const yoniEmoji = useMemo(
    () => getYoniEmojiForAvatar(avatar),
    [avatar?.dob, avatar?.design?.meta?.personality, avatar?.aggr?.city?.location],
  );

  return (
    <>

        <div
        // className={`x_user_ava ${active ? 'active' : ''}  ${type ? `x_user_ava--${type}` : ''} ${getTypeClass(design)} ${Boolean(className) ? className : ''}`}
        className={`x_user_ava x_user_ava--yoni ${active ? 'active' : ''}`}
        style={{
          borderWidth: '0.07em',
          // backgroundColor: getTypeColor(design),
          // ...style
        }}
        onClick={() => {
          onClick && onClick();
          onClickOpen && navigate(`/u/${user ? user.token : avatar.token}`);
        }}
      >
        {!noFace && !context.state.hideNames && Boolean(avatar.image) && <div className="x_user_ava_img"
          // style={{
          //   backgroundImage: `url(${avatar.image})`,
          //   // backgroundImage: `url(${avatar.image}?t=${new Date().getTime()})`,
          //   ...style,
          // }}
        />}


        {!avatar.design && !penta && <Preloader />}

        {yoniEmoji && <div className="x_user_ava_type"
          style={{ textDecoration: 'none' }}
        >
          {yoniEmoji}
        </div>}
        
        
        {!penta.members && !yoniEmoji && <div className="x_user_ava_type"
          style={{ textDecoration: 'none', lineHeight: '1' }}
        >
          <Icon size={'sm'}>question_mark</Icon>
        </div>}

        {penta.members && <div className="t_icon"
          style={{ textDecoration: 'none' }}
          >group</div>}
        </div>

    </>
  )
}